import formatPrice from 'utils/formatPrice';

const getOrderLineNarrativeDescriptionAndCost = ({ orderLine, value, index }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    if (indexOrderLine) {
      const HCPCCcode = indexOrderLine['HCPC S Code']['HCPC S Code'] || indexOrderLine['HCPC S Code'];
      return `- ${indexOrderLine.Description}, ${HCPCCcode}, ${typeof indexOrderLine.Charge === 'number'
        ? formatPrice(indexOrderLine.Charge) : ('$' + indexOrderLine.Charge.replace('$', '')) || ''}`;
    }
    return null;
  }
  return orderLine
    ? orderLine.map((item) => {
      const HCPCCcode = item['HCPC S Code']['HCPC S Code'] || item['HCPC S Code'];
      return `- ${item.Description}, ${HCPCCcode}, ${typeof item.Charge === 'number'
        ? formatPrice(item.Charge) : ('$' + item.Charge.replace('$', '')) || ''}`;
    }).join('; ')
    : null;
};

export default getOrderLineNarrativeDescriptionAndCost;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineNarrativeDescriptionAndCost.js